import React from "react";
export default function StoryPage() {
  return (
    <section className="section">
      <div className="container-gb" style={{ maxWidth: 760 }}>
        <p className="eyebrow">Történetünk</p>
        <h1 className="h-lg">Egy kis ötlet a XVII. kerületből.</h1>
        <div style={{ marginTop: 32 }}>
          <p>Az egész egy egyszerű kérdéssel kezdődött: <strong>mi lenne, ha a környéken keletkező növényi szerves anyag nem egyszerűen eltűnne a hulladékáramban?</strong></p>
          <p>Mi lenne, ha összegyűjtenénk, megfelelően kezelnénk, majd ugyanoda juttatnánk vissza, ahol keletkezett?</p>
          <p>Így született meg a GrowBag ötlete.</p>
          <p>Nem egy távoli gyárból szeretnénk egy újabb terméket a környékre hozni — hanem egy olyan helyi körforgást, amelyben a növényi anyagból újra valami hasznos születik.</p>
        </div>
        <p className="mantra" style={{ marginTop: 72 }}>
          <span>Helyben keletkezik.</span>
          <span>Helyben készül.</span>
          <span>Helyben nő tovább.</span>
        </p>
      </div>
    </section>
  );
}
